/**
 * Mapeamento oficial de DDDs do Brasil para Estados (Unidades Federativas).
 */
export const DDD_TO_STATE_MAP: Record<string, string> = {
  // São Paulo
  '11': 'São Paulo', '12': 'São Paulo', '13': 'São Paulo', '14': 'São Paulo',
  '15': 'São Paulo', '16': 'São Paulo', '17': 'São Paulo', '18': 'São Paulo', '19': 'São Paulo',
  
  // Rio de Janeiro
  '21': 'Rio de Janeiro', '22': 'Rio de Janeiro', '24': 'Rio de Janeiro',
  
  // Espírito Santo
  '27': 'Espírito Santo', '28': 'Espírito Santo',
  
  // Minas Gerais
  '31': 'Minas Gerais', '32': 'Minas Gerais', '33': 'Minas Gerais', '34': 'Minas Gerais',
  '35': 'Minas Gerais', '37': 'Minas Gerais', '38': 'Minas Gerais',
  
  // Paraná
  '41': 'Paraná', '42': 'Paraná', '43': 'Paraná', '44': 'Paraná', '45': 'Paraná', '46': 'Paraná',
  
  // Santa Catarina
  '47': 'Santa Catarina', '48': 'Santa Catarina', '49': 'Santa Catarina',
  
  // Rio Grande do Sul
  '51': 'Rio Grande do Sul', '53': 'Rio Grande do Sul', '54': 'Rio Grande do Sul', '55': 'Rio Grande do Sul',
  
  // Distrito Federal e Goiás
  '61': 'Distrito Federal', '62': 'Goiás', '64': 'Goiás',
  
  // Tocantins, Mato Grosso e Mato Grosso do Sul
  '63': 'Tocantins', '65': 'Mato Grosso', '66': 'Mato Grosso', '67': 'Mato Grosso do Sul',
  
  // Acre e Rondônia
  '68': 'Acre', '69': 'Rondônia',
  
  // Bahia e Sergipe
  '71': 'Bahia', '73': 'Bahia', '74': 'Bahia', '75': 'Bahia', '77': 'Bahia', '79': 'Sergipe',
  
  // Pernambuco e Alagoas
  '81': 'Pernambuco', '87': 'Pernambuco', '82': 'Alagoas',
  
  // Paraíba e Rio Grande do Norte
  '83': 'Paraíba', '84': 'Rio Grande do Norte',
  
  // Ceará e Piauí
  '85': 'Ceará', '88': 'Ceará', '86': 'Piauí', '89': 'Piauí',
  
  // Pará, Roraima e Amapá
  '91': 'Pará', '93': 'Pará', '94': 'Pará', '95': 'Roraima', '96': 'Amapá',
  
  // Amazonas e Maranhão
  '92': 'Amazonas', '97': 'Amazonas', '98': 'Maranhão', '99': 'Maranhão',
};

/**
 * Extrai o Estado brasileiro a partir do número de telefone informado com DDD.
 */
export function getStateFromPhone(phone?: string | null): string | undefined {
  if (!phone) return undefined;
  // Extrai apenas os números
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 2) return undefined;

  // Se começar com 55 (DDI do Brasil), pula o 55
  const ddd = digits.startsWith('55') && digits.length >= 4 
    ? digits.substring(2, 4) 
    : digits.substring(0, 2);

  return DDD_TO_STATE_MAP[ddd];
}

/**
 * Retorna o fuso horário atual do usuário ou fallback padrão de São Paulo.
 */
export function getUserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Sao_Paulo';
  } catch {
    return 'America/Sao_Paulo';
  }
}
